"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiFilledInput = void 0;
var colors_1 = require("../../generated/colors");
var global_1 = require("../../global");
exports.MuiFilledInput = {
    defaultProps: {
        disableUnderline: true,
    },
    styleOverrides: {
        root: {
            backgroundColor: colors_1.colors.Grey6,
            backgroundBlendMode: "multiply",
            borderRadius: global_1.borderRadius.input,
            borderBottom: "2px solid transparent",
            "&:hover": {
                backgroundColor: colors_1.colors.Grey6,
                borderBottom: "2px solid " + colors_1.colors.Primary,
            },
            "&.Mui-focused": {
                borderBottom: "2px solid " + colors_1.colors.Primary,
            },
            "&.Mui-error": {
                borderBottom: "2px solid " + colors_1.colors.Error,
            },
        },
        colorSecondary: {
            backgroundColor: colors_1.colors.White,
            "&:hover": {
                background: colors_1.colors.White,
            },
        },
    },
};
//# sourceMappingURL=filled-input.js.map